<template>
  <div>
  </div>
</template>

<script>
export default{
  name: 'Footer',
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue